import { useCallback } from "react";

import { useGlobalEvent } from "../../../common/hooks/useGlobalEvent";
import {
	useCartActions,
	useCartContext,
} from "../../../contexts/CartServiceContext/CartServiceContext";
import { CART_PAGE_EVENT } from "../constants";
import { duplicateCart } from "../helpers";

export const useCartItemRemove = () => {
	const { state: cart } = useCartContext((state) => state.cart);

	const actions = useCartActions();

	const removeItem = useCallback(
		(index: number) => {
			const newcart = duplicateCart(cart);

			newcart.splice(index, 1);
			actions.UPDATE_CART(newcart);
		},
		[cart]
	);

	useGlobalEvent(CART_PAGE_EVENT.CONFIRM_REMOVE_ITEM, removeItem);
};
